import Nav from "../nav/Nav";
import logo  from "../../imgs/Inverted color D20.png";

import "./Header.css"
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { selectCart } from "../../features/shopPage/shopPageSlice";
import { selectCartSidebarOpen, setCartSidebarOpen } from "../../features/cartSidebar/cartSidebarSlice";

export default function Header() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const cart = useSelector(selectCart);
    const cartSidebarIsOpen = useSelector(selectCartSidebarOpen);

    const handleLogoClick = () => {
        navigate("/");
    }

    const handleCartButtonClick = () => {
        dispatch(setCartSidebarOpen(!cartSidebarIsOpen));
    }

    return (
        <header className="header">
            <div className="title" onClick={handleLogoClick}>
                <img className="logoImage" src={logo} alt="logo"/>
                <div className="companyName">
                    <h1>Quaking Aspen</h1>
                    <h2>3D Printing</h2>
                </div>
            </div>
            <Nav />
            <div className="headerButtons">
                {cart.length ? <button onClick={handleCartButtonClick}>{`Cart (${cart.length})`}</button> : ''}
            </div>
        </header>
    )
}